import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';


@Component({
  selector: 'app-public-reputation-management',
  templateUrl: './public-reputation-management.component.html',
  styleUrls: ['./public-reputation-management.component.scss']
})
export class PublicReputationManagementComponent implements OnInit {

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0)
      }
    });
  }

  ngOnInit(): void {
  }

}
